<template>
  <div class="carousel_wrap_home">
    <el-carousel height="22vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" @click="gotoDemo()" v-if="index === 4" style="cursor: pointer"/>
        <img :src="item.src" alt="" class="img_item" v-else/>
        <div class="tips_font2" v-if="index === 4">
          <div class="title">{{ item.line1 }}</div>
          <div class="title1">{{ item.line11 }}</div>
          <div class="desc">{{ item.line2 }}</div>
          <div class="desc"><el-button type="primary" class="detail_btn" @click="gotoDemo()">查看详情</el-button></div>
        </div>
        <div class="tips_font" v-else>
          <div class="title">{{ item.line1 }}</div>
          <div class="desc">{{ item.line2 }}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="200px" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgMobileList" :key="index">
        <img :src="item.src" alt="" class="img_item" @click="gotoDemo()" v-if="index === 3" style="cursor: pointer"/>
        <img :src="item.src" alt="" class="img_item" v-else/>
        <div class="tips_font2" v-if="index === 3">
          <div class="title">{{ item.line1 }}</div>
          <div class="title1">{{ item.line11 }}</div>
          <div class="desc">{{ item.line2 }}</div>
          <div class="desc">{{ item.line22 }}</div>
          <div class="desc"><el-button type="primary" class="detail_btn" @click="gotoDemo()">查看详情</el-button></div>
        </div>
        <div class="tips_font top50" v-else-if="index === 2">
          <div class="title">{{ item.line1 }}</div>
          <div class="title">{{ item.line11 }}</div>
          <div class="desc">{{ item.line2 }}</div>
          <div class="desc">{{ item.line22 }}</div>
        </div>
        <div class="tips_font" v-else>
          <div class="title">{{ item.line1 }}</div>
          <div class="title">{{ item.line11 }}</div>
          <div class="desc">{{ item.line2 }}</div>
          <div class="desc">{{ item.line22 }}</div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          src: require('@/assets/img/banner/banner04.jpg'),
          line1: '一站式的工业智能化整体解决方案与服务',
          line2: '以ERP产品和智能制造解决方案为核心，涵盖MES、SCM、WMS、CRM等工业软件服务',
        },
        {
          src: require('@/assets/img/banner/banner03.jpg'),
          line1: '企业数智化转型解决方案供应商',
          line2: '以ERP产品和智能制造解决方案为核心，涵盖MES、SCM、WMS、CRM等工业软件服务',
        },
        {
          src: require('@/assets/img/banner/banner01.jpg'),
          line1: '数智化综合解决方案',
          line2: '面向生产企业，提供全栈式数智化综合解决方案，赋能企业的数字化转型升级',
        },
        {
          src: require('@/assets/img/banner/banner02.jpg'),
          line1: '一站式的工业智能化整体解决方案与服务',
          line2: '数智驱动企业价值，用数据做决策、用数据做管理，用更低的成本做更好的决策',
        },{
          src: require('@/assets/img/banner/banner05.jpg'),
          line1: '群晖 Synology产品',
          line11: '河南地区授权经销商',
          line2: '负责群晖产品在河南区域的销售和产品服务',
        }

      ],
      imgMobileList: [

        {
          src: require('@/assets/img/mobile/banner01.jpg'),
          line1: '企业数智化转型解决方案供应商',
          line2: '以ERP产品和智能制造解决方案为核心，',
          line22: '涵盖MES、SCM、WMS、CRM等工业软件服务',
        },
        {
          src: require('@/assets/img/mobile/banner02.jpg'),
          line1: '数智化综合解决方案区域引领者',
          line2: '为广大客户提供全栈式数智化综合解决方案，',
          line22: '赋能产业的数字化转型升级，助推中国数字经济的高质量发展',
        },
        {
          src: require('@/assets/img/mobile/banner03.jpg'),
          line1: '一站式的工业智能化',
          line11: '整体解决方案与服务',
          line2: '数智驱动企业价值，用数据做决策、用数据做管理，',
          line22: '用更低的成本做更好的决策',
        },{
          src: require('@/assets/img/mobile/banner04.jpg'),
          line1: '群晖 Synology产品',
          line11: '河南地区授权经销商',
          line2: '负责群晖产品在河南区域',
          line22: '的销售和产品服务',
        }

      ],
    }
  },
  methods:{
    gotoDemo(){
      this.$router.push('/Synology')
    }
  }
}
</script>

<style lang="scss">
.carousel_wrap_home {
  //position: relative;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
    .el-carousel__indicator--horizontal {
      padding: 0.3rem;
      .el-carousel__button{
        width: 20PX;
        height: 2PX;
      }
    }
  }
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .top50{
    top: 46PX !important; ;
  }
  .tips_font {
    position: absolute;
    width: 70%;
    margin: auto;
    top: 160px;
    left: 15%;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    text-align: center;

    @media screen and (max-width: 768px) {
      top: 70PX;
      width: 100%;
      left: 0;
    }
    .title {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 26px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5rem;
      }
    }
    .desc {
      font-size: 18px;
      margin-bottom: 1rem;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        margin-bottom: 0.2rem;
      }
    }
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
  .detail_btn{
    background-color: #00A4FF;
    width: 150px;
    padding: 10px;
    margin-top: 10px;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      width: 100PX;
      padding: 5PX;
      margin-top: 10PX;
      line-height: 1rem;
      border-radius: 3PX;
    }
  }
  .tips_font2 {
    position: absolute;
    top: 100px;
    left: 15%;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      top: 50PX;
      width: 100%;
      left: 20PX;
    }
    .title {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 10px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5rem;
      }
    }
    .title1 {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 26px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5rem;
        margin-bottom: 10PX;
      }
    }
    .desc {
      font-size: 18px;
      margin-bottom: 1rem;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        margin-bottom: 0.2rem;
      }
    }
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>